import { SingleValue } from "react-select";
import { SelectOption, GalleryData, Links, ShowAlertProps } from "../Components/common/types";

export const formatDateToMonthYear = (date: number | Date): string => {
  // Check if date is 0 (indicating "Present")
  if (date === 0) {
    return "Present";
  }
  // Handle the date normally
  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    year: "numeric",
    month: "long",
  };
  const dateObj = typeof date === "number" ? new Date(date) : date;
  return dateObj.toLocaleDateString(undefined, options);
};

// **********************************************************************************************************************
//GUARD FUNCTIONS FOR ADMIN FORM VALIDATIONS
// Type guard for SelectOption function
export function isSelectOption(
  value: unknown
): value is SingleValue<SelectOption> {
  return (
    value !== null && // Check for null
    typeof value === "object" && // Ensure value is an object
    "label" in value &&
    "value" in value &&
    typeof (value as { value: unknown }).value === "string" // Narrow value to an object with a string "value"
  );
}

//A type guard is a function that narrows down the type of a value.
export function isGalleryData(value: unknown): value is GalleryData {
  return (
    typeof value === "object" &&
    value !== null &&
    "imgData" in value &&
    "vidData" in value
  );
}

// Type guard for links
export function isLinks(value: unknown): value is Links {
  return (
    value !== null &&
    typeof value === "object" &&
    "liveDemo" in (value as Links) &&
    "github" in (value as Links)
  );
}
// **********************************************************************************************************************


// Helper function to handle token-related errors
export const handleOnOkAlert = async (
  showAlert: ShowAlertProps["showAlert"],
  setAccessToken: (token: string | null) => void,
  title: string,
  message: string
) => {
  showAlert(true, title, message, false, () => {
    // console.log("Executing onOk")
    setAccessToken(null);
    return true;
  });
};

//Check file uniquness
export const fileSignature = (file: File) => {
  const normalizedName = file.name
    .trim() // Remove leading/trailing spaces
    .replace(/\s+/g, '_') // Replace internal spaces with underscores
    .toLowerCase();
  return `${normalizedName}_${file.size}`;
};
